import React, { useEffect, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import qs from 'qs';

import Editor from '../components/Editor';
import {
	onInitEditor,
	startPreviewMode,
	applyDataIntoHtml,
	getTemplateHTML,
	loadTemplate,
} from '../utils';

const useStyles = makeStyles(() => ({
	'@global': {
		'.gjs-frame': {
			width: '100%',
			height: '100%',
		},
	},
}));

const PreviewPage = () => {
	const editorRef = useRef();
	const location = useLocation();
	const query = qs.parse(location.search, { ignoreQueryPrefix: true });

	const { template = 'template1' } = useParams();

	const isReport = template.includes('report');

	useStyles();

	useEffect(() => {
		loadTemplate({
			reportMode: isReport,
			template,
		})
			.then((response) => {
				if (response?.html) {
					return response.html;
				}
				return getTemplateHTML(template).then((htmlText) => {
					return applyDataIntoHtml(htmlText, template);
				});
			})
			.then((html) => {
				window.grapesjs.setComponents(
					html.replace(
						'<div class="report-name font-header">Financial</div>',
						`<div class="report-name font-header">${query.reportName}</div>`,
					),
				);
				startPreviewMode(window.grapesjs, template);
				setTimeout(() => {
					startPreviewMode(window.grapesjs, template);
				}, 1000);
			});
	}, [template, isReport, query]);

	const onInit = (editor) => {
		window.grapesjs = editor;
		window.reportMode = isReport;

		onInitEditor(editor, template, 'preview');
		editor.on('load', () => {
			editor.runCommand('preview');
		});
	};

	return (
		<Editor ref={editorRef} onInit={onInit} plugins={[]} pluginsOpts={{}}>
			<div />
		</Editor>
	);
};

export default PreviewPage;
